var _rect, _rect2, _rect3, _g, _path, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMenuAdvisorsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 3.48092,
    fill: "url(#paint0_linear_1381_3747)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "exclusion"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1381_3747",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 3.48092,
    fill: "url(#paint1_linear_1381_3747)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1381_3747)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -37.2664,
    y: -6.16943,
    width: 113.967,
    height: 87.2542,
    rx: 3.48092,
    fill: "#599BEA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 7.12909,
    cy: 7.12909,
    r: 7.12909,
    transform: "matrix(-1 0 0 1 43.7466 14)",
    fill: "url(#paint2_linear_1381_3747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7136 40.9322C48.0018 40.9322 48.2366 40.6984 48.2236 40.4105C48.0938 37.5191 46.8881 34.7727 44.8326 32.7172C42.6538 30.5384 39.6988 29.3144 36.6176 29.3144C33.5364 29.3144 30.5814 30.5384 28.4026 32.7171C26.3471 34.7726 25.1414 37.519 25.0115 40.4105C24.9986 40.6983 25.2334 40.9321 25.5216 40.9321L36.6176 40.9322L47.7136 40.9322Z",
    fill: "url(#paint3_linear_1381_3747)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 7.12909,
    cy: 7.12909,
    r: 7.12909,
    transform: "matrix(-1 0 0 1 23.7466 14)",
    fill: "url(#paint4_linear_1381_3747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7136 40.9322C28.0018 40.9322 28.2366 40.6984 28.2236 40.4105C28.0938 37.5191 26.8881 34.7727 24.8326 32.7172C22.6538 30.5384 19.6988 29.3144 16.6176 29.3144C13.5364 29.3144 10.5814 30.5384 8.4026 32.7171C6.34711 34.7726 5.14138 37.519 5.01152 40.4105C4.99859 40.6983 5.23341 40.9321 5.52156 40.9321L16.6176 40.9322L27.7136 40.9322Z",
    fill: "url(#paint5_linear_1381_3747)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4787 26.7147C21.2298 26.7147 17.7853 23.2702 17.7853 19.0212C17.7853 14.7723 21.2298 11.3278 25.4787 11.3278C29.7277 11.3278 33.1721 14.7723 33.1721 19.0212C33.1721 23.2702 29.7277 26.7147 25.4787 26.7147ZM34.3442 32.1037C36.6955 34.642 38.0164 38.0846 38.0164 41.6742L25.4789 41.6742L12.9415 41.6741C12.9415 38.0845 14.2624 34.6419 16.6137 32.1037C18.9649 29.5654 22.1538 28.1395 25.479 28.1395C28.8041 28.1395 31.993 29.5655 34.3442 32.1037Z",
    fill: "url(#paint6_linear_1381_3747)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 3.48092,
    fill: "#2CFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1381_3747",
    x1: 39.8667,
    y1: 5.23827e-7,
    x2: 0.859985,
    y2: 55.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51028F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388913,
    stopColor: "#220439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#632C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1381_3747",
    x1: 39.8667,
    y1: 5.23827e-7,
    x2: 0.859985,
    y2: 55.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51028F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388913,
    stopColor: "#220439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1381_3747",
    x1: 7.12909,
    y1: 7.8989,
    x2: 7.12909,
    y2: 20.6174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#832EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1381_3747",
    x1: 36.6176,
    y1: 42.1867,
    x2: 36.6176,
    y2: 62.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#832EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1381_3747",
    x1: 7.12909,
    y1: 7.8989,
    x2: 7.12909,
    y2: 20.6174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#832EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1381_3747",
    x1: 16.6176,
    y1: 42.1867,
    x2: 16.6176,
    y2: 62.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#832EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1381_3747",
    x1: 25.4789,
    y1: 28.1394,
    x2: 25.4789,
    y2: 55.2088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744562,
    stopColor: "#160829"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuAdvisorsIcon);
export default __webpack_public_path__ + "static/media/newMenuAdvisorsIcon.956210a46578a494c7b884622645e01a.svg";
export { ForwardRef as ReactComponent };